<div class="title fs-24 fw-700">{{title}}</div>

<!-- <mat-icon svgIcon="close" class="close-icon cursor-pointer" (click)="matdialogRef.close()"></mat-icon> -->
@if (showCount) {
<div class="count fs-16 fw-400">{{ processed }}/{{ total }}</div>
}

<mat-progress-bar class="progress-bar" [ngClass]="[!showCount ? 'validate-progress': 'progress-bar']" [mode]="showCount ? 'determinate' : 'indeterminate'" [value]="!showCount ? progress : total ? (processed / total) * 100 : 0"></mat-progress-bar>


<div class="component fs-16 fw-400">
  {{ currentComponent }}
</div>

<div class="hint fs-16 fw-400" [ngClass]="[!showCount ? 'validate-hint': 'hint']">
  {{'BLUEPRINT_SUMMARY.COMPONENT_INFO' | transloco}}
</div>
